import React, { useEffect, useState } from "react";

const NewCounter = ({ targetNumber, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = targetNumber / (duration / 10);

    const interval = setInterval(() => {
      start += increment;
      if (start >= targetNumber) {
        setCount(targetNumber);
        clearInterval(interval);
      } else {
        setCount(Math.floor(start));
      }
    }, 10);
    return () => clearInterval(interval);
  }, [targetNumber, duration]);
  const formattedCount = count.toLocaleString("en-IN");

  return (
    <div className="text-5xl font-extrabold text-indigo-600">
      {formattedCount}
    </div>
  );
};

export default NewCounter;
